import { initializeApiInterceptors } from '@/app/initializers/initializeApiInterceptors';
import { initializeAuth } from '@/app/initializers/initializeAuth';
import { initializeAppInsights } from '@/app/initializers/initializeAppInsights';
import { initializeFeatureFlags } from '@/app/initializers/initializeFeatureFlags';
import { initializeRollbar } from '@/app/initializers/initializeRollbar';
import { Logger } from '@fifa-bsm/bo-frontend-shared/core';
import { loadOverrides } from '@/i18n';

export const runAppInitializers = async ({ store, apiService, echoService }) => {
    initializeApiInterceptors(apiService, { store, echoService });

    await initializeAppInsights();

    await Promise.all([
        initializeFeatureFlags(store),
        loadOverrides('en').catch(),
        initializeAuth(store),
    ])
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error during app initialization!');
            Logger.error(error);
        })
        .then(() => {
            initializeRollbar(store);
        });
};
